import { InjectionToken } from '@angular/core';
import { IVimCoreTrackingConfig } from './interface';

export const TRACKING_CONFIG = new InjectionToken<IVimCoreTrackingConfig>('vimboxCore.tracking.config');
export const TRACK_CONTROL_PRESSED = 'Control Pressed';
